/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */

import firebase from "firebase/compat/app";

import "firebase/compat/app";

const firebaseConfig = process.env.REACT_APP_FIREBASE_CONFIG

export const connect = () => {
    const strConfig = atob(firebaseConfig)
    const jsonConf = JSON.parse(strConfig)
    let fire = firebase;
    fire.initializeApp(jsonConf);
    return fire;
}

export const position = async () => {
    let geo;
    if (navigator.geolocation) {
        await navigator.geolocation.getCurrentPosition((a) => {
            console.log(a);
            //localStorage.lat = a.coords.latitude;
            //localStorage.lon = a.coords.longitude;    
        });
        navigator.geolocation.watchPosition((a) => {
            console.log(a);
            //localStorage.lat = a.coords.latitude;
            //localStorage.lon = a.coords.longitude;
        });
        console.log('Geolocation is supported!');
    } else {
        console.log('Geolocation is not supported for this Browser/OS.');
    }

}
